import { useQuery } from "@tanstack/react-query";
import { fetchGalleryManifest } from "@/common/template-gallery";

/** Fetches the template gallery's manifest of available templates. */
export function useGalleryManifest() {
	return useQuery({
		queryKey: ["templateGalleryManifest"],
		queryFn: fetchGalleryManifest,
		staleTime: 5 * 60 * 1000,
	});
}
